export default __webpack_public_path__ + "static/media/pioneer.cab8ff57.webp";